// extracted by mini-css-extract-plugin
export default {"w-full":"Panel_w-full__COEML","panel":"Panel_panel__G2FKL","info":"Panel_info__y7I66","btns":"Panel_btns__uE9Hk","button":"Panel_button__Wq1Dv"};